export const formatCurrency = (
  amount: number | string,
  currency: string = 'PHP'
): string => {
  // Normalize amount
  let numericAmount = 0;
  if (typeof amount === 'string') {
    const cleaned = amount.replace(/[^\d.-]/g, '');
    numericAmount = parseFloat(cleaned) || 0;
  } else {
    numericAmount = amount ?? 0;
  }

  // Format with Intl
  return new Intl.NumberFormat('en-PH', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericAmount);
};
